import React from 'react'
import { Card, CardContent, CardHeader, CardActions, List, Divider } from '@material-ui/core'
import PlaidButton from 'components/PlaidButton'
import Provider from 'components/TrackedAccounts/Provider'
import useCurrentUserProp from 'hooks/useCurrentUserProp'

export default function TrackedAccounts() {
  const providerIds = useCurrentUserProp('trackedAccountProviders')
  // TODO: There's some minor bug on initial page load when using multiple usePlaidHook instances
  return (
    <Card>
      <CardHeader title='Tracked Accounts' />
      <CardContent>
        <List>
          {providerIds.map(id => <Provider key={id} id={id} />)}
        </List>
      </CardContent>
      <Divider />
      <CardActions>
        <PlaidButton fullWidth size='large' color='primary' variant='outlined'>
          Link More Cards
        </PlaidButton>
      </CardActions>
    </Card>
  )
}
